import React from 'react';
import { useState, useEffect } from 'react'
import {
    PageLevelMessage, IconCardContactless, dlsBrightBlue,
} from '@americanexpress/dls-react';

const ApplicationSave = () => {
    const [show, setShow] = useState(true)

    // On componentDidMount set the timer
    useEffect(() => {
        const timeId = setTimeout(() => {
            // After 5 seconds set the show value to false
            setShow(false)
        }, 5000);

        return () => {
            clearTimeout(timeId);
        }
    }, []);

    // If show is false the component will return null and stop here
    if (!show) {
        return null;
    }
    // If show is true this will be returned
        return (
            <div className="stack">
            <PageLevelMessage
                type="neutral"
                filled={true}
                icon={<IconCardContactless size="lg" filled={true} theme={dlsBrightBlue} />}>
                <p className="heading-3">Your application has been saved!</p>
                <p> You will receive an email to retrieve the saved application if you exit before submitting.</p>
            </PageLevelMessage>
        </div>
        )
}

export default ApplicationSave;